import api from '../lib/api'
import assign from 'lodash.assign'
import global from '../types/global.types'

const name = 'free-division'

export default {
  name,
  namespaced: true,
  state: {
    freeInfo: {},
    // superPaper: {},
    data: []
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    }
  },
  actions: {
    async listFree ({ commit }) {
      try {
        const { data } = await api.course.freeCourse()()
        const info = data.list[0]
        commit('set', {
          freeInfo: {
            title: '精选办公小技巧',
            itemImage: info.imageM,
            itemTitle: info.title,
            id: info.id
          }
        })
      } catch (E) {
        commit(global.ERR, '获取“免费课程”出错', { root: true })
      }
    },

    async getSuperOperation ({ commit }) {
      const { data } = await api.recommend.getSuperOperation()
      data.map((val) => {
        val.name = val.title
      })
      commit('set', {
        superPaper: {
          title: '超级简报',
          path: '/super-paper?type=1',
          list: data
        }
      })
    },

    async getData ({ commit }) {
      const { data } = await api.free.getData()
      commit('set', { data })
    },

    async init ({ dispatch }) {
      dispatch('listFree')
      dispatch('getData')
      // await dispatch('getSuperOperation')
    }
  }
}
